import { render } from "./edit_product.vue?vue&type=template&id=a4b724c0&scoped=true"
import script from "./edit_product.vue?vue&type=script&lang=js"
export * from "./edit_product.vue?vue&type=script&lang=js"

import "./edit_product.vue?vue&type=style&index=0&id=a4b724c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4b724c0"]])

export default __exports__